export class RegisterUserInput {
	public Token: string;
	public TokenRelatedEmail: string;
	public Username: string;
	public UserCompanyId: string;
	public InvitingCompanyId: string;
	public Pawd: string;
	public RepeatePawd: string;
	public Email: string;
	public Name: string;
	public Telephone: string;
	public LanguageCode: string;
	public TimeZone: string;
	public TermsAndConditionsDocumentId: string;
	public TermsAndConditionsDocumentAcceptanceHash: string;
	public PersonalDataConsentDocumentId: string;
	public InvitationLanguageCode: string;
}
